import styled, { StyledComponent } from "styled-components";

const FieldSet: StyledComponent<"fieldset", any, {}, never> = styled.fieldset`
  border: medium none;
  margin: 0 0 10px;
  min-width: 100%;
  padding: 0;
  width: 100%;
`;

const SubmitButton: StyledComponent<"button", any, {}, never> = styled.button`
  cursor: pointer;

  font-size: 1rem;
  width: 100%;
  border: none;
  background: #4caf50;
  color: #fff;
  margin: 15px 0 5px 0;
  padding: 10px;
  &:hover {
    background: #43a047;
    transition: background-color 0.3s ease-in-out;
  }
  &:active {
    box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.5);
  }
`;

export { FieldSet, SubmitButton };
